<template>
  <ValidationObserver
    ref="form"
    v-slot="{ handleSubmit }"
    slim
  >
    <form
      ref="formObj"
      :class="gridClass"
      @submit.prevent="handleSubmit(onSubmitWapper)"
    >
      <div
        v-for="(formInput, index) in formStructure"
        :key="index"
        :class="formInput.class || 'col'"
      >
        <slot
          :name="formInput.title"
          :formInputData="formInput"
          :formValue="value"
          :value="value[formInput.value]"
          :setter="setter(formInput.value)"
        >
          <ValidationProvider
            #default="{ errors }"
            :vid="formInput.title"
            :name="formInput.title"
            :rules="formInput.validation || ''"
            slim
          >
            <b-form-group
              :description="formInput.description"
              :label="formInput.title"
              :label-class="formInput.labelClass"
              :class="formInput.groupClass"
              :label-for="formInput.value"
              :invalid-feedback="errors[0]"
              :state="errors.length > 0 ? false:null"
            >
              <template #label>
                <slot
                  :name="formInput.value+'_label'"
                >
                  {{ formInput.title }}
                </slot>
              </template>
              <slot
                :name="formInput.title+'_form'"
                :value="value[formInput.value]"
                :setter="setter(formInput.value)"
              >
                <custom-form-input
                  :ref="formInput.ref"
                  :form-input="formInput"
                  :form-data="value"
                  :value="value[formInput.value]"
                  :errors="errors"
                  @input="setValue(formInput.value,$event)"
                  @builderPaste="handleBuilderPaste"
                  @builderKeyDown="handleBuilderKeyDown"
                />
              </slot>
            </b-form-group>
          </ValidationProvider>
        </slot>
      </div>
      <slot name="buttons">
        <button
          ref="submitBtn"
          class="d-none"
          type="submit"
        >
          Submit
        </button>
      </slot>
    </form>
    <slot name="footer" />
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BFormGroup } from 'bootstrap-vue'
import CustomFormInput from './CustomFormInput.vue'

export default {
  components: {
    ValidationProvider, ValidationObserver, BFormGroup, CustomFormInput,
  },
  props: {
    gridClass: {
      type: String,
      default: () => 'row',
    },
    formStructure: {
      type: Array,
      default: () => [],
    },
    value: undefined,
    onSubmit: {
      type: Function,
      default: () => null,
    },
  },
  watch: {
    value(value) {
      this.$emit('input', value)
    },
  },
  created() {
    this.formStructure.filter(x => x.default).forEach(x => { this.value[x.value] = x.default })
  },
  methods: {
    handleBuilderPaste(pastedText) {
      this.$emit('waybillPaste', pastedText)
    },
    handleBuilderKeyDown(waybill) {
      this.$emit('waybillScan', waybill)
    },
    onSubmitWapper() {
      this.onSubmit(this.value)
    },
    clearValidation() {
      this.$refs.form.reset()
    },
    reset() {
      const value = {}
      this.formStructure.filter(x => x.default).forEach(x => { value[x.value] = x.default })
      this.$emit('input', value)
      this.$refs.form.reset()
    },
    setValue(path, data) {
      this.$set(this.value, path, data)
      this.$emit(`${path}OnChange`, data)
      this.$emit('input', this.value)
      this.$emit(`${path}OnChanged`, data)
    },
    submit() {
      this.$refs.submitBtn.click()
    },
    setter(value) {
      return input => {
        this.$set(this.value, value, input)
        this.$emit('input', this.value)
      }
    },
  },
}
</script>

<style>
</style>
